import React from "react";
import {
    Avatar,
    Dialog,
    DialogTitle,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    TextField
} from "@mui/material";
import {blue} from "@mui/material/colors";
import {Day} from "../core/Day";
import Box from "@mui/material/Box";
import {Option} from "../core/Option";
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';

interface IProps{
    open: boolean;
    handleClose: () => void;
    month: number;
    day: number;
    dayModel: Day;
    availableOptions: Option[];
    handleDayModelChange: (dayModel: Day) => void;
}
export default function DayPopup(props: IProps)
{
    const { open, handleClose, day: dayNumber, month: monthNumber, dayModel: day, availableOptions, handleDayModelChange } = props;

    const handleOptionToggle = (option: Option) => {

        let addOption = true;
        for (const selectedOption of day.selectedOptions) {
            if(selectedOption.serialize() === option.serialize())
            {
                addOption = false;
                day.selectedOptions.delete(selectedOption);
                break;
            }
        }
        if(addOption)
        {
            day.selectedOptions.add(option);
        }

        handleDayModelChange(day);
    }

    const handleCommentChange = (value: string) => {
        day.comment = value;

        handleDayModelChange(day);
    }

    const getMonthName = (monthNumber: number) => {
        // Create a date object with the desired month (1-based indexing)
        const date = new Date(2000, monthNumber - 1); // Year and day are arbitrary
        // Use toLocaleString to get the localized month name
        return date.toLocaleString(undefined, { month: "short" }); // undefined uses PC's locale
    }

    const slugify = (str: string): string => {
        str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
        str = str.toLowerCase(); // convert string to lowercase
        str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
            .replace(/\s+/g, '-') // replace spaces with hyphens
            .replace(/-+/g, '-'); // remove consecutive hyphens
        return str;
    }

    const isSelected = (option: Option): boolean => {

        let isSelected = false;
        day.selectedOptions.forEach((selectedOption) => {
            if(isSelected) return true;
            isSelected = selectedOption.serialize() === option.serialize();
        });

        return isSelected;
    }

    return (
        <Dialog onClose={handleClose} open={open} >
            <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold', fontSize: '15px'}}>{getMonthName(monthNumber)} {dayNumber}</DialogTitle>
            <Box sx={{position: 'absolute', right: '8px', top: '8px'}} onClick={handleClose} >
                <CloseIcon />
            </Box>
            <Box sx={{
                maxWidth: 'inherit',
                width: '70vw',
                height: '80vh'
            }}>
                <Box sx={{
                    display: 'grid',
                    rowGap: 4,
                    gridTemplateColumns: '1fr 1fr',
                    py: 4,
                }}>
                    {
                        availableOptions.map((availableOption) => {

                            return (
                                <Box key={`popup-${monthNumber}-${dayNumber}-availableOption-${slugify(availableOption.name)}`}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: availableOption.color,
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: 2,
                                            border: isSelected(availableOption) ? '2px solid black' : undefined,
                                        }}
                                        onClick={() => handleOptionToggle(availableOption)}
                                    />

                                    <Typography> {availableOption.name} </Typography>
                                </Box>
                            )

                        })
                    }
                </Box>

                <Box
                    sx={{
                        pt: 2,
                        margin: 'auto',
                        width: '80%'
                    }}
                >
                    <TextField
                        label={"Comment"}
                        variant={"standard"}
                        fullWidth={true}
                        value={day.comment}
                        multiline={true}
                        onChange={(e) => handleCommentChange(e.target.value)}
                    />
                </Box>

            </Box>

        </Dialog>
    );
}